module.exports = __webpack_public_path__ + "static/media/SN_23291_Vorwerk_GA_TM31_ES_160921.d8e4550c.pdf";